<template>
  <div
    v-if="hasRoles('R&D', 'HRL')"
    class="q-pa-lg flex flex-center"
  >
    <q-form
      ref="validateForm"
      @submit="onSubmit"
      greedy
    >
      <fieldset class="q-gutter-md">
        <h5 align="center">
          <span v-if="isAdd">
            Add Email Template
          </span>
          <span v-else>
            Edit Email Template
          </span>
        </h5>
        <div class="row">
          <q-select
          class="col-12"
          label="Email Template Type *"
          v-model="emailTemplate.emailTemplateType"
          @update:model-value="(val) => updateEmailTemplateName(val)"
          map-options
          emit-value
          :options="[
          { label: 'Manual Send', value: 'ManualSend'},
          {
            label: 'Application Submitted To Student',
            value: 'ApplicationSubmittedToStudent'
          },
          { label: 'Application Submitted To Housing', value: 'ApplicationSubmittedToHousing' },
          { label: 'Placement Confirmation To Student', value: 'PlacementConfirmationToStudent' },
          { label: 'DSS Requested To DSS', value: 'DssRequestedToDss' },
          { label: 'DSS Requested  To Student', value: 'DssRequestedToStudent'}]"

            :rules="[checkSelect]"
            lazy-rules
          />
          <q-input
            v-model.trim="emailTemplate.emailTemplateName"
            class="col-12 q-mr-md"
            label="Email Template Name *"
            :rules="[checkInput]"
            lazy-rules
          />
          <q-input
            v-model.trim="emailTemplate.from"
            class="col-12 q-mr-md"
            label="From"
            :rules="[checkInput]"
            lazy-rules
          />
          <q-input
            v-model.trim="emailTemplate.to"
            class="col-12 q-mr-md"
            label="To"
            :rules="[checkInput]"
            lazy-rules
            disable
          />
          <q-input
            v-model.trim="emailTemplate.cc"
            class="col-12 q-mr-md"
            label="Cc"
            :rules="[true]"
          />
          <q-input
            v-model.trim="emailTemplate.bcc"
            class="col-12 q-mr-md"
            label="Bcc"
            :rules="[true]"
          />
          <q-editor
            v-model="emailTemplate.subject"
            ref="subjectRef"
            class="col-12 q-mr-md"
            :toolbar="[['viewsource'], ['token']]"
            placeholder="Enter Subject Here.."
            min-height="24px"
            max-height="20vh"
          >
              <template v-slot:token>
                <q-btn-dropdown
                  dense
                  no-caps
                  ref="tokenRef"
                  no-wrap
                  unelevated
                  color="white"
                  text-color="primary"
                  label="Subject Tokens"
                  size="sm"
                >
                  <q-list dense>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Application_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Application Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Deposit_Amount')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Amount</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Deposit_Refund_Amount')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Refund Amount</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Deposit_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Dss_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Dss Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'First_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>First Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Last_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Last Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Preferred_First_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Preferred First Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Residency_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Residency Status</q-item-section>
                    </q-item>
                      <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Move_In_Group')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Move in Group</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Vaccine_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Vaccine Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(subjectRef, 'Session_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Session Name</q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </template>
            </q-editor>
          <q-editor
            max-height = "60vh"
            v-model="emailTemplate.body"
            ref="editorRef"
            class="col-12 q-mr-md"
            :dense="$q.screen.lt.md"
            placeholder="Enter Body Here.."
              :toolbar="[
    ['token', 'token2', 'token3'],
                ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript','link'],
                [
                  {
                    icon: $q.iconSet.editor.formatting,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'p',
                      'h1',
                      'h2',
                      'h3',
                      'h4',
                      'h5',
                      'h6',
                      'code'
                    ]
                  },
                  {
                    icon: $q.iconSet.editor.fontSize,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'size-1',
                      'size-2',
                      'size-3',
                      'size-4',
                      'size-5',
                      'size-6',
                      'size-7'
                    ]
                  },
                  {
                    icon: $q.iconSet.editor.font,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: [
                      'default_font',
                      'arial',
                      'arial_black',
                      'comic_sans',
                      'courier_new',
                      'impact',
                      'lucida_grande',
                      'times_new_roman',
                      'verdana'
                    ]
                  },
                  'removeFormat'
                ],
                ['unordered', 'ordered',
                  {
                    icon: $q.iconSet.editor.align,
                    fixedLabel: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                  }
  ],
  ['viewsource']
              ]"
              :fonts="{
                arial: 'Arial',
                arial_black: 'Arial Black',
                comic_sans: 'Comic Sans MS',
                courier_new: 'Courier New',
                impact: 'Impact',
                lucida_grande: 'Lucida Grande',
                times_new_roman: 'Times New Roman',
                verdana: 'Verdana'
              }"
            >
              <template v-slot:token>
                <q-btn-dropdown
                  dense
                  no-caps
                  ref="tokenRef"
                  no-wrap
                  unelevated
                  color="white"
                  text-color="primary"
                  label="Application Tokens"
                  size="sm"
                >
                  <q-list dense>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Application_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Application Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Colleague_ID')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Colleague ID</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Date_Of_Birth')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Date Of Birth</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Deposit_Amount')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Amount</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Deposit_Refund_Amount')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Refund Amount</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Deposit_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Deposit Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'DigiPen_Email')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>DigiPen Email</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Dss_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Dss Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'First_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>First Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Last_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Last Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Preferred_First_Name')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Preferred First Name</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Residency_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Residency Status</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Move_In_Group')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Move in Group</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Student_Mobile_Phone')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Student Mobile Phone</q-item-section>
                    </q-item>
                    <q-item
                      tag="label"
                      clickable
                      @click="addToken(editorRef, 'Vaccine_Status')"
                    >
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Vaccine Status</q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </template>
              <template v-slot:token2>
                <q-btn-dropdown
                  dense
                  no-caps
                  ref="tokenRef"
                  no-wrap
                  unelevated
                  color="white"
                  text-color="primary"
                  label="Session Tokens"
                  size="sm"
                >
                  <q-list dense>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Session_Name')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Session Name</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Agreement_Url')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Agreement Url</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Dss_Url')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Dss Url</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Session_Description')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Session Description</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Vaccination_Url')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Vaccination Url</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Application_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Application Deadline</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Student_Facing_Application_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Student Facing Application Deadline</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Continuing_Move_Out_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Continuing Move Out Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Non_Continuing_Move_Out_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Non Continuing Move Out Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Returning_Student_Move_In_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Returning Student Move In Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'First_Year_Student_Move_In_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>First Year Student Move In Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Priority_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Priority Deadline</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Compliance_Or_Quit_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Compliance Or Quit Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Paperwork_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Paperwork Deadline</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Payment_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Payment Deadline</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Placement_Communication_Date')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Placement Communication Date</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Priority_First_Year_Confirmation_of_Space')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Priority First Year Confirmation of Space</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'General_First_Year_Confirmation_of_Space')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>General First Year Confirmation of Space</q-item-section>
                      </q-item>
                      <q-item
                        tag="label"
                        clickable
                        @click="addToken(editorRef, 'Cancellation_Deposit_Refund_Deadline')"
                      >
                        <q-item-section side>
                          <q-icon name="mail" />
                        </q-item-section>
                        <q-item-section>Cancellation Deposit Refund Deadline</q-item-section>
                      </q-item>
                  </q-list>
                </q-btn-dropdown>
              </template>
              <template v-slot:token3
                v-if="emailTemplate.emailTemplateType === 'PlacementConfirmationToStudent'
                || emailTemplate.emailTemplateType === 'ManualSend'">
                <q-btn-dropdown
                  dense
                  no-caps
                  ref="tokenRef"
                  no-wrap
                  unelevated
                  color="white"
                  text-color="primary"
                  label="Placement Tokens"
                  size="sm"
                >
                  <q-list dense>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Unit_Name')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Unit Name</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Complex_Name')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Complex Name</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Complex_City')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Complex City</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Complex_State')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Complex State</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Complex_Zip')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Complex Zip</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Complex_Address')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Complex Address</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Placement_Status')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Placement Status</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Room_Rate_Table')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Room Rate Table</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Room_Name')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Room Name</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Room_Type')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Room Type</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Roommates_Table')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Roommates Table</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Door_Code')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Door Code</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Mailbox_Number')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Mailbox Number</q-item-section>
                    </q-item>
                    <q-item tag="label"
                            clickable
                            @click="addToken(editorRef, 'Amenity_Codes_Table')">
                      <q-item-section side>
                        <q-icon name="mail" />
                      </q-item-section>
                      <q-item-section>Amenity Codes Table</q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </template>
            </q-editor>
          <q-uploader
            v-if="emailTemplate.emailTemplateType !== 'PlacementConfirmationToStudent'"
            class="col-11 q-ma-md"
            :url="blobUrl"
            max-files="1"
            accept=".pdf"
            max-file-size=20971520
            auto-upload
            @added="clearExistingPdf('attachmentBlob')"
            @uploaded="fileUploaded"
          >
            <template v-slot:header="scope">
              <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                <div class="col">
                  <div class="q-uploader__title">Upload attachement pdf</div>
                </div>
                <q-btn
                  v-if="!emailTemplate.attachmentId"
                  type="a"
                  icon-right="add_box"
                  dense
                  flat
                >
                  <q-uploader-add-trigger style="z-index: 1" />
                  <q-tooltip>Upload attachement pdf</q-tooltip>
                </q-btn>
                <q-btn
                  v-if="emailTemplate.attachmentId || scope.uploadedFiles.length > 0"
                  icon="download"
                  @click="exportPdf(
                  emailTemplate.attachmentId,
                  'emailTemplateBlob',
                  emailTemplate.attachmentName,
                  false)"
                  dense
                  flat
                >
                  <q-tooltip>Download current attachement pdf</q-tooltip>
                </q-btn>
              </div>
            </template>
            <template v-slot:list="scope">
              <q-list separator>

                <q-item
                  v-for="file in scope.files"
                  :key="file.name"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file.name }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: {{ file.__status }}
                    </q-item-label>

                    <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label>
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteAttachmentBlob(scope, file)"
                    ></q-btn>
                  </q-item-section>
                </q-item>
                <q-item
                  v-for="file in attachementBlobs"
                  :key="file"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: uploaded
                    </q-item-label>
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteAttachmentBlob(scope, file)"
                    ></q-btn>
                  </q-item-section>
                </q-item>

              </q-list>
            </template>
          </q-uploader>
        </div>
      </fieldset>
        <h5 align="center">
          <span>
           Send Test Email
          </span>
        </h5>
      <q-input
        v-model.trim="emailTemplate.sendTestTo"
        class="col-5 q-mr-md"
        label="Send test email to *"
      />
      <q-select
        label="Test Session"
        v-model="emailTemplate.testSessionId"
        :options="sessionNameIds"
        emit-value
        map-options
        option-value="sessionId"
        option-label="sessionName"
        @update:model-value="(val) => getTestUserEmailIds(val)"
      />
      <q-select
        v-if="emailTemplate.testSessionId"
        label="Test applicant data"
        v-model="emailTemplate.testUserApplicationId"
        :options="applicationsEmailIds"
        emit-value
        map-options
        option-value="applicationId"
        option-label="digipenEmail"
      />
      <div
      align="center"
      class="q-gutter-sm q-mt-md"
      >
       <q-btn
          label="Send Test Email"
          color="primary"
          @click="onSubmitTestEmail()"
        />
        <q-btn
          flat
          label="Cancel"
          v-close-popup
          color="primary"
        />
        <q-btn
          flat
          label="Save"
          @click="submitForm()"
          color="positive"
        />
      </div>
    </q-form>
  </div>
</template>

<script setup>
import {
  ref,
  // defineExpose,
  onMounted,
  onUnmounted,
} from 'vue';
import { uid, useQuasar } from 'quasar';
import useAuth from '@/hooks/auth';
import useEmailTemplate from '@/hooks/email';
import useUiValidations from '@/utilities/uiValidations';
import useUiUtilities from '@/utilities/uiUtilities';
import useApplication from '@/hooks/application';
import useSession from '@/hooks/session';
import useUtility from '@/hooks/utility';

const {
  checkInput,
  checkSelect,
} = useUiValidations();

const $q = useQuasar();
const { hasRoles } = useAuth();
const {
  createEmailTemplate,
  emailTemplate,
  updateEmailTemplate,
  updateEmailTemplateName,
  resetCurrentEmailTemplate,
  sendTestEmail,
  emailTemplates,
  getAllEmailTemplates,
  isEmailModalActive,
} = useEmailTemplate();
const { exportPdf, notifyResult } = useUiUtilities();
const { deleteBlobDocument } = useUtility();
const { getApplicationsEmailIds } = useApplication();
const { fetchSessionNameIds } = useSession();

const isAdd = ref(true);
const tokenRef = ref(null);
const editorRef = ref(null);
const subjectRef = ref(null);
const applicationsEmailIds = ref(null);
const sessionNameIds = ref(null);
const attachementBlobs = ref([]);
const blobUrl = ref('');
const validateForm = ref(false);

onMounted(() => {
  isAdd.value = !emailTemplate.value.emailTemplateId || emailTemplate.value.emailTemplateId === 0;
});

onUnmounted(() => {
  resetCurrentEmailTemplate();
});

sessionNameIds.value = await fetchSessionNameIds();

const onSubmitTestEmail = async () => {
  const isValidated = await validateForm.value.validate();
  if (!isValidated
    || !emailTemplate.value.testSessionId
    || !emailTemplate.value.testUserApplicationId) {
    $q.notify({
      message: 'Please fill in test session, test applicant, and any other fields with validation errors.',
      color: 'warning',
      position: 'top',
    });
    return;
  }
  $q.loading.show();
  const response = await sendTestEmail();
  notifyResult(response.status, response, false, 'Test email sent successfully');
  $q.loading.hide();
};

const onSubmit = async () => {
  const isValidated = await validateForm.value.validate();
  if (isValidated) {
    let response = '';
    if (isAdd.value) {
      response = await createEmailTemplate();
    } else {
      response = await updateEmailTemplate();
    }
    notifyResult(response.status, response);

    return response;
  }

  return false;
};

const submitForm = async () => {
  $q.loading.show();
  const response = await onSubmit();
  if (response?.status === 200 || response?.status === 201) {
    emailTemplates.value = await getAllEmailTemplates();
    isEmailModalActive.value = false;
  }
  $q.loading.hide();
};

const addToken = (edit, name) => {
  tokenRef.value.hide();
  edit.caret.restore();
  const tempId = uid();
  edit.runCmd('insertText', tempId);
  if (edit === editorRef.value) {
    emailTemplate.value.body = emailTemplate.value.body.replace(tempId, `<span class="variable" contenteditable="false">${name}</span>`);
  } else {
    emailTemplate.value.subject = emailTemplate.value.subject.replace(tempId, `<span class="variable" contenteditable="false">${name}</span>`);
  }
  edit.focus();
};

const getTestUserEmailIds = async (val) => {
  applicationsEmailIds.value = await getApplicationsEmailIds(val);
};

const updateBlobUrls = () => {
  const temp = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/uploadBlobDocument?`;
  blobUrl.value = emailTemplate.value.attachmentId
    ? `${temp}&blobGeneralId=${emailTemplate.value.attachmentId}&blobName=EmailTemplateBlob`
    : `${temp}&blobName=EmailTemplateBlob`;
};
const clearExistingPdf = () => {
  attachementBlobs.value = [];
};
const fileUploaded = ({ xhr }) => {
  const response = JSON.parse(xhr.response);
  emailTemplate.value.attachmentId = response.item1;
  updateBlobUrls();
};
const deleteAttachmentBlob = async (scope, file) => {
  $q.loading.show();
  clearExistingPdf();
  scope.removeFile(file);
  await deleteBlobDocument(emailTemplate.value.attachmentId);
  emailTemplate.value.attachmentId = null;
  $q.loading.hide();
};
updateBlobUrls();
attachementBlobs.value = emailTemplate.value.attachmentName
  ? [emailTemplate.value.attachmentName] : [];

// defineExpose({
//   onSubmit,
//   onSubmitTestEmail,
// });
</script>

<!-- .variable class should not be updated.
  If updating, server regex must match the same format for email template variables to function. -->
<style lang="css">
.variable {
  background: #11BBA4;
  color: white;
  padding: 3px;
  border-radius: 5px;
}
</style>
